import { FUNDRAISE_WISE_DONATIONS_LIST_API_URL } from "../components/Shared/constant";

const GetFundraiseDonationsAPI = async (accessToken, slug, userLimit, currentPage , {signal}={}) => {
    const responce = window.axios.get(`${FUNDRAISE_WISE_DONATIONS_LIST_API_URL}/${slug}/donation/list/${userLimit}/${currentPage}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    },signal:signal}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetFundraiseDonationsAPI;